import { updateMemberPaid } from '@/api/orders';
import { SNACKBAR_TYPES } from '@/utils/constants';
import bus from '@/utils/bus';

export default {
  name: 'PaidAll',
  props: {
    orderId: {
      required: true,
      type: Number,
    },
    value: {
      required: true,
      type: Boolean,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  methods: {
    async onConfirm() {
      try {
        this.loading = true;
        await updateMemberPaid(this.orderId);
        bus.$emit('GET_ORDER_INFOS');
        this.close();
      } catch (error) {
        const { message } = error;
        const errorMessage = message ? `（錯誤：${message}）` : '';

        this.$snackbar({
          type: SNACKBAR_TYPES.ERROR,
          title: '收款失敗',
          msg: `處理收款資料時發生問題，請稍後再試。${errorMessage}`,
        });
      } finally {
        this.loading = false;
      }
    },
    close() {
      this.$emit('input', false);
    },
  },
};
